export default __webpack_public_path__ + "static/media/video-play-img.fc95f621.svg";